/**
 * Created by rhinov8e on 27/07/2016.
 */

import { ActionState, ActionStateEnum, EditModeEnum, EditEntitiesState, EditEntityState, DragCoatingState, DragComponentState, AreaState, FloorCoatingAreaState, MoveFunctionalityChipState, AreaStateEditModeEnum, AddEntityState } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { EntityManager } from "../../plan/EntityManager";

import { CocosUtils } from "../../../../tools/CocosUtils";
import { IdleEditState } from "./IdleEditState";
import async from "async";
import { PlanManager } from "../../../../cocosPlan";
import { ArrangementGroup, arrangementManager, ArrangementObject, Coating, Commands, Component, ComponentConstants, Entity, EntityDefaultPropertiesManager, Event, Events, eventsManager, FunctionalityChip, GeometryGroup, GeometryPrimitive, HttpService, Listener, math, planManager, RenderCamera, Room, roomManager, SceneConstants, Sun, Wall, WorkTop } from "@rhinov/savane-js";
import { _ASSET_TYPE, createAssetEntity, getToken, getUrl, loadPopulatedObjects, switchPopulatedObjects } from "@rhinov/asset-manager-service";

declare var cc: any;
// declare var AiDrapesService: any;

export class IdleDecoration extends IdleEditState {

    isDragging: boolean = false;
    displayWarning: boolean = false;
    ctrlOn: boolean = PlanManager.getInstance()._uiState.ctrlPressed;
    shiftOn: boolean = false;
    altOn: boolean = false;
    plusPressed: boolean = false;
    minusPressed: boolean = false;
    hPressed: boolean = false;
    pendingFlip: boolean = false;//A flip action is currently occuring
    sunDrag: boolean = false;
    hasBeenEdited: boolean = false;
    coatingDrag: Listener | null = null;

    lessListener: Listener | null = null;
    deleteListener: Listener | null = null;
    modifyListener: Listener | null = null;
    editedListener: Listener | null = null;
    plusListener: Listener | null = null;
    imageListener: Listener | null = null;
    chipFuncAddListener: Listener | null = null;
    chipFuncRemoveListener: Listener | null = null;
    chipFuncEditionListener: Listener | null = null;
    entityEdition: Listener | null = null;
    joineryComponentDrag: Listener | null = null;
    technicalElementComponentDrag: Listener | null = null;
    ungroupEntitiesListener: Listener | null = null;
    ungroupEntityListener: Listener | null = null;
    groupEntitiesListener: Listener | null = null;
    mergeEntitiesListener: Listener | null = null;
    clearCoatingListener: Listener | null = null;
    sliderListener: Listener | null = null;
    sunDragOnListener: Listener | null = null;
    sunDragOffListener: Listener | null = null;
    constructor() {
        super();
        this.state = ActionStateEnum.idleDecoration;

       
        this.vPressed = false;
        
        this.bPressed = false;

        

        //Attach listeners
        this.lessListener = eventsManager.instance.addListener(Events.LESS_CLICKED, this.plusOrLessClickedHandler.bind(this));
        this.deleteListener = eventsManager.instance.addListener(Events.DELETE_EVENT, this.actionDelete.bind(this));
        this.modifyListener = eventsManager.instance.addListener(Events.TEXTFIELD_EDIT_ENDED, (event: any) => {
            this.actionTextFieldEditEnded(event.getUserData());
        });
        this.editedListener = eventsManager.instance.addListener(Events.TEXTFIELD_EDIT, (event: any) => {
            this.actionTextFieldEdit(event.getUserData().editedProperty, event.getUserData().value, event.getUserData().obj, false);
        });
        this.plusListener = eventsManager.instance.addListener(Events.PLUS_CLICKED, this.plusOrLessClickedHandler.bind(this));
        this.imageListener = eventsManager.instance.addListener(Events.IMAGE_CLICKED, this.actionChangeArrangementObjectId.bind(this));
        //SavaneJS events
        //Listen for func chip add
        this.chipFuncAddListener = new Listener((data: any) => {
            this.addRoomFunc(data.userData.functionality, data.userData.room, data.userData.edit);
        });
        eventsManager.instance.addListenerObject(Events.ADD_ROOM_SECONDARY_FUNCTIONALITY, this.chipFuncAddListener);
        //Listen for func chip remove
        this.chipFuncRemoveListener = new Listener((data: any) => {
            this.removeRoomFunc(data.userData.functionality, data.userData.room, data.userData.edit);
        });
        eventsManager.instance.addListenerObject(Events.REMOVE_ROOM_SECONDARY_FUNCTIONALITY, this.chipFuncRemoveListener);
        //Listen for func chip edition
        this.chipFuncEditionListener = new Listener((data: any) => {
            this.changeToChipFunctionalityEdition(data.userData.functionality, data.userData.room);
        });
        eventsManager.instance.addListenerObject(Events.CHIP_FUNC_EDITION, this.chipFuncEditionListener);
        this.entityEdition = new Listener((data: any) => {
            this.changeToEntityEdition(data.userData.entity);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.entityEdition);
        this.coatingDrag = new Listener((data: any) => {
            this.changeToCoatingAdd(data.userData.entity, data.userData.coating);
        });
        eventsManager.instance.addListenerObject(Events.COATING_DRAG, this.coatingDrag);
        this.joineryComponentDrag = new Listener((datas: any) => {
            this.changeToDragTechnicalElement(datas.userData.entity, datas.userData.joineryComponent, true, [SceneConstants.EntityType.Joinery]);
            /*  var newState = new DragComponentState(datas.userData.joinery, true, [SceneConstants.EntityType.Joinery]);
            eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);*/
        });
        eventsManager.instance.addListenerObject(Events.JOINERY_COMPONENT_DRAG, this.joineryComponentDrag);

        this.technicalElementComponentDrag = new Listener((datas: any) => {
            this.changeToDragTechnicalElement(datas.userData.entity, datas.userData.technicalComponent, true, [SceneConstants.EntityType.TechnicalElement]);
        });
        eventsManager.instance.addListenerObject(Events.TECHNICAL_ELEMENT_COMPONENT_DRAG, this.technicalElementComponentDrag);

        this.ungroupEntitiesListener = eventsManager.instance.addListener(Events.UNGROUP_ENTITIES, this.actionUngroup);
        this.ungroupEntityListener = eventsManager.instance.addListener(Events.UNGROUP_ENTITY, this.actionLeaveGroup);
        this.groupEntitiesListener = eventsManager.instance.addListener(Events.GROUP_ENTITIES, this.actionGroup);
        this.mergeEntitiesListener = eventsManager.instance.addListener(Events.MERGE_ENTITIES, this.actionMerge);
        this.clearCoatingListener = eventsManager.instance.addListener(Events.COATING_REMOVE, this.actionRemoveCoating);
        this.sliderListener = eventsManager.instance.addListener(Events.SLIDER_BUTTON, this.sliderButtonHandler.bind(this));
       
        this.sunDragOnListener = eventsManager.instance.addListener(Events.SUN_DRAG_ON, () => {
            this.sunDrag = true;
        });
        this.sunDragOffListener = eventsManager.instance.addListener(Events.SUN_DRAG_OFF, () => {
            this.sunDrag = false;
        });

        this.selectedItem = null;
        if (PlanManager.getInstance().selectedEntities != null &&
            PlanManager.getInstance().selectedEntities.length > 0) {
            this.selectedItem = PlanManager.getInstance().selectedEntities[0];
        }

        
    }

    initialize() {
        if (PlanManager.getInstance().scrollWindow.grid.getGridVisibility() === true) {
            PlanManager.getInstance().mustShowGrid = false;
            PlanManager.getInstance().scrollWindow.grid.setGridVisibility(false);
            PlanManager.getInstance().scrollWindow.refreshGrid();
        }

        eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, true);
        PlanManager.getInstance().mustShowPlan = false;
        eventsManager.instance.dispatch(Events.TOGGLE_PLAN, false);
    }

    getAction(): number {
        return ActionStateEnum.idleDecoration;
    }

    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        PlanManager.getInstance().scrollWindow._cancelDragging();
        return null;
    }

    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();

        this.actionEditEnded();

        if (this.ctrlOn) {
            if (hoverEntities !== null && hoverEntities.length !== 0) {
                if (cocosplanManager.selectedEntities.length === 0) {
                    if (this.shiftOn) {
                        cocosplanManager.updateItemsSelected(hoverEntities, false, mouseButton === 2);
                    }
                    else {
                        cocosplanManager.updateItemsSelected([hoverEntities[0]], false, mouseButton === 2);
                    }
                    return (null);
                }
                else {
                    var selectedEntities = cocosplanManager.selectedEntities.slice();
                    var entitiesToAdd;
                    var i;

                    if (this.shiftOn) {
                        entitiesToAdd = hoverEntities;
                    }
                    else {
                        entitiesToAdd = [hoverEntities[0]];
                    }

                    if ((selectedEntities[0].isArrangementObjectEntity() ||
                        selectedEntities[0].isArrangementGroupEntity() ||
                        selectedEntities[0].isRenderCameraEntity() ||
                        selectedEntities[0].isGeometryPrimitiveEntity() ||
                        selectedEntities[0].isGeometryGroupEntity()) &&
                        (selectedEntities[0].parent &&
                            !(selectedEntities[0].parent.isArrangementGroupEntity() || selectedEntities[0].parent.isGeometryGroupEntity()))) {
                        for (i = 0; i < entitiesToAdd.length; i++) {
                            var entityHover = entitiesToAdd[i];
                            var toAdd = true;
                            var alreadySelectedIndex = -1;

                            for (var j = 0; j < cocosplanManager.selectedEntities.length; j++) {
                                if (entityHover.id === cocosplanManager.selectedEntities[j].id && entityHover.entityType === cocosplanManager.selectedEntities[j].entityType) {
                                    toAdd = false;
                                    alreadySelectedIndex = j;
                                    break;
                                }
                                if (entityHover.entityType !== cocosplanManager.selectedEntities[j].entityType) {
                                    if (entityHover.isArrangementObjectEntity() || entityHover.isArrangementGroupEntity() || 
                                        entityHover.isGeometryPrimitiveEntity() || entityHover.isGeometryGroupEntity()) {
                                        if (!cocosplanManager.selectedEntities[j].isArrangementObjectEntity() && !cocosplanManager.selectedEntities[j].isArrangementGroupEntity() &&
                                            !cocosplanManager.selectedEntities[j].isGeometryPrimitiveEntity() && !cocosplanManager.selectedEntities[j].isGeometryGroupEntity()) {
                                            toAdd = false;
                                            alreadySelectedIndex = j;
                                            break;
                                        }
                                    }
                                    else {
                                        toAdd = false;
                                        alreadySelectedIndex = j;
                                        break;
                                    }
                                }
                            }

                            if (toAdd) {
                                if ((entityHover.isArrangementObjectEntity() ||
                                    entityHover.isArrangementGroupEntity() ||
                                    entityHover.isRenderCameraEntity() ||
                                    entityHover.isGeometryPrimitiveEntity() ||
                                    entityHover.isGeometryGroupEntity()) &&
                                    (entityHover.parent &&
                                        !(entityHover.parent.isArrangementGroupEntity() || entityHover.parent.isGeometryGroupEntity()))) {
                                    selectedEntities.push(entityHover);
                                }
                            } else if (doubleClick) {
                                selectedEntities.splice(alreadySelectedIndex, 1);
                            }
                        }
                    }

                    // Do we have to open the tulip at when showing selected items ?
                    var showTulip = mouseButton === 2;

                    // Only if no render camera or light in the selected entities
                    for (i = 0; i < selectedEntities.length; i++) {
                        if (selectedEntities[i].isRenderCameraEntity()) {
                            showTulip = false;
                            break;
                        }
                    }

                    cocosplanManager.updateItemsSelected(selectedEntities, false, showTulip);

                    if (selectedEntities.length > 0 &&
                        (selectedEntities[0].isArrangementObjectEntity() ||
                            selectedEntities[0].isArrangementGroupEntity() ||
                            selectedEntities[0].isRenderCameraEntity() ||
                            selectedEntities[0].isGeometryPrimitiveEntity() ||
                            selectedEntities[0].isGeometryGroupEntity())) {
                        var state: ActionState = new EditEntitiesState(selectedEntities, cursorPosition);
                        return state;
                    }
                }
            }
        } else if (this.shiftOn) {
            if (cocosplanManager.selectedEntities.length === 1 &&
                cocosplanManager.selectedEntities[0].isArrangementGroupEntity()) {
                var arr = arrangementManager.getArrangementAtPosition(cursorPosition, cocosplanManager.selectedEntities[0] as ArrangementGroup, PlanManager.getInstance().world.currentScene!.currentFloor!);
                if (arr !== null) {
                    cocosplanManager.updateItemsSelected([arr], false, mouseButton === 2);
                }
            }
            else if (hoverEntities !== null && hoverEntities.length === 1 &&
                hoverEntities[0] instanceof ArrangementGroup) {
                var arr = arrangementManager.getArrangementAtPosition(cursorPosition, hoverEntities[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                if (arr !== null) {
                    cocosplanManager.updateItemsSelected([arr], false, mouseButton === 2);
                }
                else {
                    cocosplanManager.updateItemsSelected(hoverEntities, false, mouseButton === 2);
                }
            } else {
                if (cocosplanManager.selectedEntities.length > 0) {
                    PlanManager.getInstance().duplicateElement(cocosplanManager.selectedEntities);
                }
            }
        } else {
            if (cocosplanManager.selectedEntities.length === 1 &&
                (cocosplanManager.selectedEntities[0].isArrangementObjectEntity() ||
                    cocosplanManager.selectedEntities[0].isArrangementGroupEntity() ||
                    cocosplanManager.selectedEntities[0].isRenderCameraEntity() ||
                    cocosplanManager.selectedEntities[0].isGeometryPrimitiveEntity() ||
                    cocosplanManager.selectedEntities[0].isGeometryGroupEntity())) {
                var node = EntityManager.getInstance().getNode(cocosplanManager.selectedEntities[0]);
                if (node !== null) {
                    if (node.resizeMenu !== undefined) {
                        if ((node.toRotate(cocosplanManager._uiState.unsnappedCursorPosition) || node.toResize(cocosplanManager._uiState.unsnappedCursorPosition))) {
                            return new EditEntityState(cocosplanManager.selectedEntities[0], cursorPosition, node.toRotate(cocosplanManager._uiState.unsnappedCursorPosition), EditModeEnum.rotate, node.toResize(cocosplanManager._uiState.unsnappedCursorPosition));
                        }
                    }

                    if (node.toRotate(cocosplanManager._uiState.unsnappedCursorPosition)) {
                        return new EditEntityState(cocosplanManager.selectedEntities[0], cursorPosition, node.toRotate(cocosplanManager._uiState.unsnappedCursorPosition), EditModeEnum.rotate);
                    }
                }
            }

            if (hoverEntities !== null && hoverEntities.length !== 0) {
                if (!hoverEntities[0].isWallEntity() &&
                    !hoverEntities[0].isJoineryEntity() &&
                    !hoverEntities[0].isTechnicalElementEntity() &&
                    !hoverEntities[0].isRoomEntity() &&
                    !hoverEntities[0].isStaircaseEntity() &&
                    !hoverEntities[0].isUserPictureEntity() &&
                    !hoverEntities[0].isFunctionalityChipEntity()) {
                    var state: ActionState = new EditEntityState(hoverEntities[0], cursorPosition, undefined, undefined, undefined, mouseButton === 2);

                    if (hoverEntities[0].isArrangementObjectEntity()) {
                        eventsManager.instance.dispatch(Events.SET_FILTERS, {
                            entity: hoverEntities[0]
                        });
                    }

                    if ((state as EditEntityState).node !== null) {
                        return state;
                    } else {
                        this.dispose();
                        return new IdleDecoration();
                    }
                }
                else {
                    var coatingArea = planManager.getAreaAtPosition(cursorPosition, [
                        ComponentConstants.ComponentType.FloorCoatingArea
                    ], false, PlanManager.getInstance().world.currentScene!.currentFloor!);
                    if (hoverEntities[0] instanceof FunctionalityChip) {
                        this.dispose();
                        return new MoveFunctionalityChipState(hoverEntities[0].parent as Room, hoverEntities[0], cursorPosition, false);
                    } else if (coatingArea && (hoverEntities === null || hoverEntities.length === 0 || hoverEntities[0].isRoomEntity())) {
                        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.FloorCoatingArea);
                        return new FloorCoatingAreaState(coatingArea, AreaStateEditModeEnum.area_selected, cursorPosition);
                    } else {
                        PlanManager.getInstance().updateItemsSelected(hoverEntities, false, mouseButton === 2);
                        this.dispose();
                        return new IdleDecoration();
                    }
                }
            } else {
                var coatingArea = planManager.getAreaAtPosition(cursorPosition, [
                        ComponentConstants.ComponentType.FloorCoatingArea
                    ], false, PlanManager.getInstance().world.currentScene!.currentFloor!);
                if (coatingArea) {
                    eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.FloorCoatingArea);
                    return new FloorCoatingAreaState(coatingArea, AreaStateEditModeEnum.area_selected, cursorPosition);
                }
                PlanManager.getInstance().updateItemsSelected(null);
            }
        }
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        this.isDragging = true;
        PlanManager.getInstance().scrollWindow._startDragging(posx, posy, true);
        return null;
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (this.isDragging) {
            var posx = cursorPosition[0] / 10;
            var posy = cursorPosition[1] / 10;
            PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);
        }

        this.isDragging = false;
        return null;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        if (this.sunDrag) {
            this.isDragging = false;
        }
        if (this.isDragging) {
            var posx = cursorPosition[0] / 10;
            var posy = cursorPosition[1] / 10;
            PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);
        }
        super.moveMouseCursor(cursorPosition);
        return null;
    }

    replaceWithObject(oldEntity: ArrangementObject, arrayObj: any, index: number, oldObjects: any, newObjectsAndParents: any, callback: any) {
        createAssetEntity(_ASSET_TYPE.ARRANGEMENTS, arrayObj[index], true, (newEntity: any) => {
            math.mat4.copy(newEntity.transform.localMatrix, oldEntity.transform.globalMatrix);
            // Save group altervatives
            newEntity.closeObjects = arrayObj;
            // Save current alternative number
            newEntity.closeCurrentObject = index;
            // Disable anchoring to prevent updateFloorHeight
            newEntity.isAnchorActive = false;

            // Adapt floor height according to object height change
            var position = oldEntity.position;
            if (oldEntity.anchor && oldEntity.anchor[1] === -3) {
                position[2] += (oldEntity.realHeight - newEntity.realHeight) / 2;
            } else {
                position[2] -= (oldEntity.realHeight - newEntity.realHeight) / 2;
            }
            newEntity.position = position;

            oldObjects.push(oldEntity);
            newObjectsAndParents.push({ entity: newEntity, parent: oldEntity.parent });
            callback();
        });
    }

    loadCloseObjects(entity: ArrangementObject, add: any, oldObjects: any, newObjectsAndParents: any, callback: any) {
        var minlength;
        var maxlength;
        var percent = 10;

        if (entity.length > 400) {
            percent = 50;
        }

        minlength = entity.length - (entity.length * percent / 100);
        maxlength = entity.length + (entity.length * percent / 100);

        var url = getUrl() + 'api/v1/assets?q.objectType.eq=' + entity.objectType +
            '&fields=marketName,price,genericName,name,dimensions,sketchBlock,_id,marketLink,configs,stretchability,objectType,coatingType,manufacturer,retailer,pipeline,styles,type' +
            '&q.dimensions.width.bt=' + minlength + ',' + maxlength +
            '&q.pipeline.state.in=available,archived&sort=dimensions.width&q.pipeline.modelState.eq=validated&limit=-1';

        if (entity.objectStyles && entity.objectStyles.length > 0) {
            url += "&q.styles.in=";
            for (var i = 0; i < entity.objectStyles.length; i++) {
                url += entity.objectStyles[i]._id;
                if (i < entity.objectStyles.length - 1) {
                    url += ",";
                }
            }
        }
        url += '&apikey=' + getToken();

        HttpService.get(url)
            .then(
                (response: any) => {
                    //success
                    if (response.status === 200 && response.data && response.data.resources && response.data.resources.length > 0) {
                        // We search for the current resource within the current returned data
                        for (var i = 0; i < response.data.resources.length; i++) {
                            if (entity.objectId === response.data.resources[i]._id) {
                                // Found
                                break;
                            }
                        }

                        // Not found search the closest
                        if (i >= response.data.resources.length) {
                            for (var i = 0; i < response.data.resources.length; i++) {
                                if (entity.length === response.data.resources[i].dimensions.width) {
                                    // Found
                                    break;
                                }

                                if (entity.length < response.data.resources[i].dimensions.width) {
                                    // Found
                                    if (add < 0) {
                                        i += add;
                                    }
                                    break;
                                }
                            }
                        }
                        else {
                            i += add;
                        }

                        if (i >= response.data.resources.length) {
                            i = response.data.resources.length - 1;
                        }
                        if (i < 0) {
                            i = 0;
                        }

                        this.replaceWithObject(entity, response.data.resources, i, oldObjects, newObjectsAndParents, callback);
                    }
                    else {
                        this.displayWarning = true;
                        callback();
                    }
                },
                (_response: any) => {
                    callback();
                }
            );
    }

    switchCloseObjects(entity: any, add: any, oldObjects: any, newObjectsAndParents: any, callback: any) {
        if (entity.closeObjects !== undefined) {
            if (entity.closeObjects.length > 1) {
                var configNb = entity.closeCurrentObject + add;
                if (configNb >= entity.closeObjects.length) {
                    configNb = entity.closeObjects.length - 1;
                }
                if (configNb < 0) {
                    configNb = 0;
                }
                this.replaceWithObject(entity, entity.closeObjects, configNb, oldObjects, newObjectsAndParents, callback);
            }
        }
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();
        var currentSelection = cocosplanManager.selectedEntities;

        if (keyCode === cc.KEY.v) {
            this.vPressed = true;
        }
        if (keyCode === cc.KEY.b) {
            this.bPressed = true;
        }
        if (keyCode === cc.KEY.h) {
            this.hPressed = true;
        }
        if (keyCode === cc.KEY.alt) {
            this.altOn = true;
        }
        if (this.altOn && (keyCode === cc.KEY.left || keyCode === cc.KEY.right)) {
            for (var i = 0 ; i < currentSelection.length ; i++) {
                if (currentSelection[i].isArrangementGroupEntity()) {
                    var mat = math.mat4.create();
                    var arrList = (currentSelection[i] as ArrangementGroup).arrangementObjectsRec;

                    mat[0] = -1;

                    for (var j = 0 ; j < arrList.length ; j++) {
                        //math.mat4.multiply(arrList[j].transform.localMatrix, mat, arrList[j].transform.localMatrix);
                        arrList[j].transform.localMatrix[12] = -arrList[j].transform.localMatrix[12];
                        arrList[j].transform.localZRotation = -arrList[j].transform.localZRotation;
                    }

                    var arrGroupList = (currentSelection[i] as ArrangementGroup).arrangementGroups;
                    for (var j = 0 ; j < arrGroupList.length ; j++) {
                        //math.mat4.multiply(arrGroupList[j].transform.localMatrix, mat, arrGroupList[j].transform.localMatrix);
                        arrGroupList[j].transform.localMatrix[12] = -arrGroupList[j].transform.localMatrix[12];
                        arrGroupList[j].transform.localZRotation = -arrGroupList[j].transform.localZRotation;
                    }
                    for (var j = 0 ; j < arrGroupList.length ; j++) {
                        arrGroupList[j].recenter();
                    }

                    currentSelection[i].recenter();
                }
            }
        }
        if (this.ctrlOn && keyCode === cc.KEY.c) {
            if (currentSelection.length === 1 && currentSelection[0].isRoomEntity()) {
                var room: Room = currentSelection[0] as Room;
                var components = room.getComponents(ComponentConstants.ComponentType.Coating) as Coating[];

                for (var i = 0 ; i < components.length ; i++) {
                    if (components[i].hangType === Coating.HangType.floor) {
                        EntityDefaultPropertiesManager.getInstance().setRoomCoatingClipboard(components[i]);
                    }
                }
            }
        }
        if (this.ctrlOn && keyCode === cc.KEY.v) {
            if (currentSelection.length === 1 && currentSelection[0].isRoomEntity()) {
                    if (EntityDefaultPropertiesManager.getInstance().getRoomCoatingClipboard()) {
                        cocosplanManager.executeCommand(new Commands.AddComponentCommand(EntityDefaultPropertiesManager.getInstance().getRoomCoatingClipboard()!.clone(), currentSelection[0], true, true));
                    }
            }
        }
        if (keyCode === cc.KEY.l) {
            if (!this.ctrlOn && !this.shiftOn) {
                for (var i = 0; i < currentSelection.length; i++) {
                    currentSelection[i].locked = !currentSelection[i].locked;
                }
            }
            else {
                var locked = this.ctrlOn;
                var arrangementObjects = cocosplanManager.world.currentScene!.currentFloor!.arrangementObjectsRec;
                var arrangementGroups = cocosplanManager.world.currentScene!.currentFloor!.arrangementGroups;

                for (var i = 0; i < arrangementObjects.length; i++) {
                    arrangementObjects[i].locked = locked;
                }
                for (var i = 0; i < arrangementGroups.length; i++) {
                    arrangementGroups[i].locked = locked;
                }
            }
        }
        if (keyCode === 107) {
            this.plusPressed = true;
            if (currentSelection.length === 1 && currentSelection[0].isArrangementGroupEntity()) {
                if (this.hPressed) {
                    this.scaleGroup(currentSelection[0], 1.1, 1);
                }
                if (this.vPressed) {
                    this.scaleGroup(currentSelection[0], 1, 1.1);
                }
                if (!this.vPressed && !this.hPressed) {
                    this.scaleGroup(currentSelection[0], 1.1, 1.1);
                }
            }
        }
        if (keyCode === 109) {
            this.minusPressed = true;
            if (currentSelection.length === 1 && currentSelection[0].isArrangementGroupEntity()) {
                if (this.hPressed) {
                    this.scaleGroup(currentSelection[0], 1 / 1.1, 1);
                }
                if (this.vPressed) {
                    this.scaleGroup(currentSelection[0], 1, 1 / 1.1);
                }
                if (!this.vPressed && !this.hPressed) {
                    this.scaleGroup(currentSelection[0], 1 / 1.1, 1 / 1.1);
                }
            }
        }
        if (keyCode == cc.KEY.d) {
            if (this.selectedItem !== null) {
                if (!(this.selectedItem instanceof Room)) {
                    var position: math.vec3 | undefined;

                    if (this.selectedItem instanceof Wall) {
                        //position = (this.selectedItem.begin + this.selectedItem.end) / 2
                    }
                    else {
                        position = this.selectedItem.position;
                    }

                    // Check if the selected object is in a room
                    let room: Room | null = position !== undefined ? roomManager.getRoomAtPosition(position, cocosplanManager.world.currentScene!.currentFloor!) : null;

                    if (room !== null) {
                        // Yes, draw dimensions for the room around the object (managed by game object manager)
                        GameObjectManager.drawObjectAroundDimension(this.selectedItem, room);
                    }
                }
                if (this.selectedItem.isArrangementObjectEntity()) {
                    var node = EntityManager.getInstance().getNode(this.selectedItem);

                    if (node) {
                        node.setForceDimensions(true);
                    }
                }
            }
        }
        if (keyCode == cc.KEY.Delete || keyCode == cc.KEY.backspace) {
            this.actionDelete();
        } else if (keyCode == cc.KEY.ctrl) {
            this.ctrlOn = true;
        } else if (keyCode == cc.KEY.shift) {
            this.shiftOn = true;
        } else if (keyCode == cc.KEY.g) {
            this.actionGroup();
        } else if (keyCode == cc.KEY.u) {
            this.actionUngroup();
        } else if (keyCode == cc.KEY.l) {
            this.actionLeaveGroup();
        }
        if (keyCode == cc.KEY.e) {
            var selection = [];
            for (var i = 0; i < cocosplanManager.selectedEntities.length; ++i) {
                var entity = cocosplanManager.selectedEntities[i];
                if (entity.locked !== true && (
                    entity.isRenderCameraEntity() ||
                    entity.isArrangementGroupEntity() ||
                    entity.isArrangementObjectEntity() ||
                    entity.isGeometryPrimitiveEntity())) {
                    selection.push(entity);
                }
            }

            if (selection.length > 0) {
                return new EditEntitiesState(selection, cocosplanManager._uiState.cursorPosition, EditModeEnum.rotate);
            }
        }
        if (keyCode == cc.KEY.i) {
            if (cocosplanManager.selectedEntities.length === 1 && cocosplanManager.selectedEntities[0].isRoomEntity()) {
                if (this.ctrlOn) {
                    eventsManager.instance.dispatch(Events.SHOW_THIS_ROOM, { room: cocosplanManager.selectedEntities[0] });
                } else {
                    eventsManager.instance.dispatch(Events.HIDE_OTHER_ROOMS, { room: cocosplanManager.selectedEntities[0] });
                }
            } else if (cocosplanManager.selectedEntities.length === 0 && this.ctrlOn) {
                eventsManager.instance.dispatch(Events.SHOW_ALL_ROOMS);
            }
        }
        // CTRL+ALT+x enable stretchability
        if (this.altOn && this.ctrlOn && keyCode === cc.KEY.x) {
            var activated = 0;

            for (var i = 0; i < currentSelection.length; ++i) {
                var entity = currentSelection[i];
                if (entity instanceof ArrangementObject && entity.locked !== true && entity.stretchability === undefined) {
                    entity.enableStretchability();

                    var node = EntityManager.getInstance().getNode(entity);
                    if (node !== null) {
                        node.addStretchability(true);
                        node.updateSprite();
                        node.needRedraw = true;
                    }

                    activated++;
                }
            }

            if (activated === 1) {
                cocosplanManager.updateItemsSelected(currentSelection, true, true);
            }
        }
        // CTRL+ALT+w disable stretchability
        if (this.altOn && this.ctrlOn && keyCode === cc.KEY.w) {
            var activated = 0;

            for (var i = 0; i < currentSelection.length; ++i) {
                var entity = currentSelection[i];
                if (entity instanceof ArrangementObject && entity.locked !== true && entity.stretchability && entity.excludeFromShoppingList === true) {
                    entity.disableStretchability();

                    var node = EntityManager.getInstance().getNode(entity);
                    if (node !== null) {
                        node.addStretchability(false);
                        node.updateSprite();
                        node.needRedraw = true;
                    }

                    activated++;
                }
            }

            if (activated === 1) {
                cocosplanManager.updateItemsSelected(currentSelection, true, true);
            }
        }

        if (this.altOn && this.ctrlOn && keyCode === cc.KEY.d) {
            CocosUtils.cleanWorldTemplates();
        }

        // Auto populate of complex object like table, bib, dressing etc
        if (this.bPressed) {
            var newObjectsAndParents: any[] = [];
            var oldObjects: any[] = [];

            switch (keyCode) {
                case cc.KEY.left:
                    // if(!AiDrapesService.solutionExists(cocosplanManager.world.currentScene!.parent) && currentSelection.length === 0){
                    //     AiDrapesService.generateDrapesSolutionForScene(cocosplanManager.world.currentScene!.parent,
                    //         (l_returnedArray: any, l_toDelete: any) => {
                    //             if(l_returnedArray !== undefined && l_returnedArray.length === 0
                    //             && l_toDelete !== undefined && l_toDelete.length === 0 )
                    //             {
                    //                 eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { error: true, title: 'Opération peuplement', message: 'Impossible de générer les rideaux. Assets introuvables.' });
                    //                 return;
                    //             }
                    //             for (const del of l_toDelete)
                    //             {
                    //                 cocosplanManager.executeCommand(new Commands.DeleteEntityCommand(del.entity, undefined as any));
                    //             }
                    //             cocosplanManager.executeCommand(new Commands.AddEntitiesCommand(l_returnedArray, false, true, false));
                    //         });
                    // }else{
                    //     if(currentSelection.length === 1 && currentSelection[0].isJoineryEntity())
                    //     {
                    //         AiDrapesService.iterateDrapesSolutionForGroup(currentSelection[0],-1,
                    //             (l_returnedArray: any, l_toDelete: any) =>
                    //             {
                    //                 if(l_returnedArray !== undefined && l_returnedArray.length === 0
                    //                     && l_toDelete !== undefined && l_toDelete.length === 0 )
                    //                 {
                    //                     eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { error: true, title: 'Opération peuplement', message: 'Impossible de générer les rideaux. Assets introuvables.' });
                    //                     return;
                    //                 }
                    //                 for (const del of l_toDelete)
                    //                 {
                    //                     cocosplanManager.executeCommand(new Commands.DeleteEntityCommand(del.entity, undefined as any));
                    //                 }
                    //                 cocosplanManager.executeCommand(new Commands.AddEntitiesCommand(l_returnedArray, false, true, false));
                    //             });
                    //     }
                    // }

                    async.eachSeries(currentSelection, (entity: any, endCallback: any) => {
                        if (entity.isArrangementObjectEntity()) {
                            loadPopulatedObjects(entity, oldObjects, newObjectsAndParents, null, "b2c,b2b,content_factory", (_displayWarning: any) => {
                                endCallback();
                            });
                        }
                        else {
                            if (entity.isArrangementGroupEntity()) {
                                switchPopulatedObjects(entity, -1, oldObjects, newObjectsAndParents, (_displayWarning: any) => {
                                    endCallback();
                                });
                            }
                        }
                    },
                        () => {
                            if (oldObjects.length > 0) {
                                cocosplanManager.executeCommand(new Commands.ReplaceEntitiesCommand(oldObjects, newObjectsAndParents));
                            }
                            else {
                                eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { error: true, title: 'Opération peuplement', message: 'impossible sur au moins un sélectionné.' });
                            }
                        });
                    break;
                case cc.KEY.right:
                    // if(!AiDrapesService.solutionExists(cocosplanManager.world.currentScene!.parent) && currentSelection.length === 0)
                    // {
                    //     AiDrapesService.generateDrapesSolutionForScene(cocosplanManager.world.currentScene!.parent,
                    //         (l_returnedArray: any, l_toDelete: any) =>
                    //         {
                    //             for (const del of l_toDelete)
                    //             {
                    //                 cocosplanManager.executeCommand(new Commands.DeleteEntityCommand(del.entity, undefined as any));
                    //             }
                    //             cocosplanManager.executeCommand(new Commands.AddEntitiesCommand(l_returnedArray, false, true, false));
                    //             //AiDrapesService.SolutionExists = true;
                    //         });
                    // }else{
                    //     if(currentSelection.length === 1 && currentSelection[0].isJoineryEntity())
                    //     {
                    //         AiDrapesService.iterateDrapesSolutionForGroup(currentSelection[0],1,
                    //             (l_returnedArray: any, l_toDelete: any) =>
                    //             {
                    //                 for (const del of l_toDelete)
                    //                 {
                    //                     cocosplanManager.executeCommand(new Commands.DeleteEntityCommand(del.entity, undefined as any));
                    //                 }
                    //                 cocosplanManager.executeCommand(new Commands.AddEntitiesCommand(l_returnedArray, false, true, false));

                    //             });
                    //     }
                    // }

                    async.eachSeries(currentSelection, (entity: any, endCallback: any) => {
                        if (entity.isArrangementObjectEntity()) {
                            loadPopulatedObjects(entity, oldObjects, newObjectsAndParents, null, "b2c,b2b,content_factory", (_displayWarning: any) => {
                                endCallback();
                            });
                        }
                        else {
                            if (entity.isArrangementGroupEntity()) {
                                switchPopulatedObjects(entity, 1, oldObjects, newObjectsAndParents, (_displayWarning: any) => {
                                    endCallback();
                                });
                            }
                        }
                    },
                        () => {
                            if (oldObjects.length > 0) {
                                cocosplanManager.executeCommand(new Commands.ReplaceEntitiesCommand(oldObjects, newObjectsAndParents));
                            }
                            else {
                                eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { error: true, title: 'Opération peuplement', message: 'impossible sur au moins un sélectionné.' });
                            }
                        });
                    break;

                case cc.KEY.down:
                    for (var i = 0 ; i < currentSelection.length ; i++) {
                        if (currentSelection[i].isArrangementGroupEntity()) {
                            if ((currentSelection[i] as ArrangementGroup).masterObjectId) {
                                for (var j = 0; j < currentSelection[i].children.length; j++) {
                                    if ((currentSelection[i].children[j] as ArrangementObject).objectId === (currentSelection[i] as ArrangementGroup).masterObjectId) {
                                        oldObjects.push(currentSelection[i]);
                                        newObjectsAndParents.push({ entity: currentSelection[i].children[j], parent: currentSelection[i].parent });
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if (oldObjects.length > 0) {
                        cocosplanManager.executeCommand(new Commands.ReplaceEntitiesCommand(oldObjects, newObjectsAndParents));
                    }
                    break;
            }
        }

        // Close objects
        if (this.vPressed) {
            let vNewObjectsAndParents: any[] = [];
            let vOldObjects: any[] = [];

            switch (keyCode) {
                case cc.KEY.left:
                    this.displayWarning = false;
                    async.eachSeries(currentSelection, (entity: any, endCallback: any) => {
                        if (entity.isArrangementObjectEntity()) {
                            if (entity.closeObjects === undefined) {
                                this.loadCloseObjects(entity, -1, vOldObjects, vNewObjectsAndParents, () => {
                                    endCallback();
                                });
                            }
                            else {
                                this.switchCloseObjects(entity, -1, vOldObjects, vNewObjectsAndParents, () => {
                                    endCallback();
                                });
                            }
                        }
                    },
                        (_err: any) => {
                            if (vOldObjects.length > 0) {
                                cocosplanManager.executeCommand(new Commands.ReplaceEntitiesCommand(vOldObjects, vNewObjectsAndParents));
                            }

                            if (this.displayWarning) {
                                eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'L\'opération demandée n\'a pas pu être effectuée sur au moins un des objets sélectionnés.' });
                            }
                        });
                    break;
                case cc.KEY.right:
                    this.displayWarning = false;

                    async.eachSeries(currentSelection, (entity: any, endCallback: any) => {
                        if (entity.isArrangementObjectEntity()) {
                            if (entity.closeObjects === undefined) {
                                this.loadCloseObjects(entity, 1, vOldObjects, vNewObjectsAndParents, () => {
                                    endCallback();
                                });
                            }
                            else {
                                this.switchCloseObjects(entity, 1, vOldObjects, vNewObjectsAndParents, () => {
                                    endCallback();
                                });
                            }
                        }
                    },
                        (_err: any) => {
                            if (vOldObjects.length > 0) {
                                cocosplanManager.executeCommand(new Commands.ReplaceEntitiesCommand(vOldObjects, vNewObjectsAndParents));
                            }

                            if (this.displayWarning) {
                                eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'L\'opération demandée n\'a pas pu être effectuée sur au moins un des objets sélectionnés.' });
                            }
                        });
            }
        }
        if (keyCode === cc.KEY.i && !this.ctrlOn) {
            cocosplanManager.executeCommand(new Commands.SnapEntitiesCommand(currentSelection, Commands.SnapEntitiesCommand.SnapEnum.CenterOnTop));
        }
        // Camera shortcuts
        if ((keyCode === cc.KEY.a || keyCode === cc.KEY.p || keyCode === cc.KEY.h || keyCode === cc.KEY.v || keyCode === cc.KEY.r || keyCode === cc.KEY.c) && this.shiftOn) {
            this.changeCameras(keyCode);
        }

        if (keyCode === cc.KEY.o) {
            // Toggle holdout
            for (var i = 0; i < cocosplanManager.selectedEntities.length; ++i) {
                var entity = cocosplanManager.selectedEntities[i];
                entity.holdout = !entity.holdout;
                eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                    name: Commands.CommandEnum.ChangeCoatingCommand,
                    undo: false,
                    datas: {entity: entity, component: {}}
                });
            }
        }

        return super.keyPressed(keyCode);
    }


    changeCameras(keyCode: number) {
        var selectedEntities = PlanManager.getInstance().selectedEntities;

        for (var i = 0 ; i < selectedEntities.length ; i++) {
            var entity = selectedEntities[i];
            if (entity instanceof RenderCamera) {
                entity.startTemporary();
                if (entity.cameraType !== SceneConstants.CameraType.Perspective) {
                    entity.fov = entity.fov = SceneConstants.CameraPerspectiveOriginalFOV;;
                }
                switch(keyCode)
                {
                    case cc.KEY.a:
                        entity.cameraType = SceneConstants.CameraType.Axonomic;
                        break;
                    case cc.KEY.p:
                        entity.cameraType = SceneConstants.CameraType.Panoramic;
                        break;
                    case cc.KEY.r:
                        entity.cameraType = SceneConstants.CameraType.Storage;
                        break;
                    case cc.KEY.c:
                        if (entity.cameraType !== SceneConstants.CameraType.Perspective && entity.cameraType !== SceneConstants.CameraType.Storage) {
                            entity.cameraType = SceneConstants.CameraType.Perspective;
                        }
                        entity.format = SceneConstants.CameraPreset.NormalSquare;
                        break;
                    case cc.KEY.h:
                        if (entity.cameraType !== SceneConstants.CameraType.Perspective && entity.cameraType !== SceneConstants.CameraType.Storage) {
                            entity.cameraType = SceneConstants.CameraType.Perspective;
                        }
                        entity.format = SceneConstants.CameraPreset.NormalPaysage;
                        break;
                    case cc.KEY.v:
                        if (entity.cameraType !== SceneConstants.CameraType.Perspective && entity.cameraType !== SceneConstants.CameraType.Storage) {
                            entity.cameraType = SceneConstants.CameraType.Perspective;
                        }
                        entity.format = SceneConstants.CameraPreset.NormalPortrait;
                        break;
                }

                if (entity.cameraType !== (entity as any)._cameraType) {
                    entity.updateCameraNb(PlanManager.getInstance().world);
                }

                PlanManager.getInstance().executeCommand(new Commands.EditRenderCameraCommand(entity, false));

                eventsManager.instance.dispatch(Events.COMMAND_EXECUTED,
                {
                    name: Commands.CommandEnum.EditEntityCommand,
                    undo: false,
                    datas: {
                        id: entity.id,
                        type: entity.entityType,
                        select: true
                    }
                });
            }
        }
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();

        // Scaling mode
        if (keyCode === cc.KEY.v) {
            this.vPressed = false;
        }
        if (keyCode === cc.KEY.b) {
            this.bPressed = false;
        }
        if (keyCode === cc.KEY.h) {
            this.hPressed = false;
        }
        if (keyCode === cc.KEY.alt) {
            this.altOn = false;
        }
        if (keyCode === 107) {
            this.plusPressed = false;
        }
        if (keyCode === 109) {
            this.minusPressed = false;
        }
        if (keyCode === cc.KEY.d) {
            GameObjectManager.deleteObjectAroundDimension();
            if (this.selectedItem && this.selectedItem.isArrangementObjectEntity()) {
                var node = EntityManager.getInstance().getNode(this.selectedItem);

                if (node) {
                    node.setForceDimensions(false);
                }
            }
        }
        if (keyCode == cc.KEY.ctrl) {
            this.ctrlOn = false;
        } else if (keyCode == cc.KEY.shift) {
            this.shiftOn = false;
        }
        if (this.pendingFlip && (keyCode == cc.KEY.up || keyCode == cc.KEY.down || keyCode == cc.KEY.left || keyCode == cc.KEY.right)) {
            var entity = cocosplanManager.selectedEntities[0];
            var node = EntityManager.getInstance().getNode(entity);
            if (entity.isValid(cocosplanManager.world.currentScene!.currentFloor!)) {
                cocosplanManager.executeCommand(new Commands.EditEntityCommand(entity));
                cocosplanManager.updateItemsSelected([entity]);
            } else {
                entity.endTemporary();
                if (node) node.setValidity(entity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));
            }
        }

        return super.keyUnPressed(keyCode);
    }

    isDecorationState(): boolean {
        return (true);
    }

    scaleGroup(group: any, factorX: any, factorY: any) {
        var entities = [];

        entities.push(group);

        for (var i = 0; i < group.children.length; i++) {
            entities.push(group.children[i]);

            group.children[i].startTemporary();
            var pos = math.vec3.create();
            math.vec3.set(pos, group.children[i].localPosition[0] * factorX, group.children[i].localPosition[1] * factorY, group.children[i].localPosition[2]);

            group.children[i].localPosition = pos;
        }

        PlanManager.getInstance().executeCommand(new Commands.EditEntitiesCommand(entities));

        PlanManager.getInstance().updateItemsSelected([group]);
    }

    startEdit() {
        if (this.selectedItem !== null) {
            this.selectedItem.startTemporary();
        }
    }

    sliderButtonHandler(event: Event) {
        this.selectedItem = event.getUserData().obj;

        if (!this.hasBeenEdited) {
            this.startEdit();
        }

        if (this.selectedItem != null) {
            var value = event.getUserData().value;

            // Normal property field of an entity
            if ((this.selectedItem as any)[event.getUserData().editedProperty] !== undefined) {
                (this.selectedItem as any)[event.getUserData().editedProperty] = value;
            }
            else {
                // Property not found, check if this is a functionality chip and in that case, set the property in data if it exists
                if (this.selectedItem instanceof FunctionalityChip || this.selectedItem instanceof Room) {
                    if (this.selectedItem.getData(event.getUserData().editedProperty) !== undefined) {
                        this.selectedItem.setData(event.getUserData().editedProperty, value)
                    }
                }
            }
            eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE);
        }

        this.hasBeenEdited = true;
    }

    actionDelete() {
        var cocosplanManager = PlanManager.getInstance();
        var selectedEntities = cocosplanManager.selectedEntities;
        //List all selected entities eligible for delete
        var toDeleteEntities = [];

        if (selectedEntities.length === 0) {
            var backPlan = cocosplanManager.world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage);

            if (backPlan !== null) {
                cocosplanManager.executeCommand(new Commands.DeleteComponentCommand(backPlan, false));
            }
        }

        for (var i = 0; i < selectedEntities.length; i++) {
            if (selectedEntities[i].locked !== true && (selectedEntities[i].isRenderCameraEntity() ||
                selectedEntities[i].isArrangementGroupEntity() || selectedEntities[i].isArrangementObjectEntity() ||
                selectedEntities[i].isGeometryPrimitiveEntity() || selectedEntities[i].isGeometryGroupEntity())) {

                if (!selectedEntities[i].isArrangementObjectEntity() || (selectedEntities[i] as ArrangementObject).canLeaveGroup()) {
                    toDeleteEntities.push(selectedEntities[i]);
                }
            }
        }
        
        if (toDeleteEntities.length > 0) {
            cocosplanManager.executeCommand(new Commands.DeleteEntitiesCommand(toDeleteEntities));
        }
        this.selectedItem = null;
    }

    actionGroup(): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();
        if (cocosplanManager.selectedEntities.length > 1) {
            if (cocosplanManager.selectedEntities[0].isIArrangementEntity()) {
                var selection = cocosplanManager.selectedEntities.filter((item) => item.isIArrangementEntity());
                if (selection.length > 1) {
                    cocosplanManager.executeCommand(new Commands.CreateGroupCommand(selection as ArrangementGroup[]));
                }
            } else if (cocosplanManager.selectedEntities[0].isIGeometryEntity()) {
                var selection = cocosplanManager.selectedEntities.filter((item) => item.isIGeometryEntity());
                if (selection.length > 1) {
                    cocosplanManager.executeCommand(new Commands.CreateGeometryGroupCommand(selection as GeometryGroup[]));
                }
            }
        }
        return null;
    }
    actionMerge(): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();
        if (cocosplanManager.selectedEntities.length > 1) {
            var merge = true;

            for (var i = 0 ; i < cocosplanManager.selectedEntities.length ; i++) {
                if (cocosplanManager.selectedEntities[i].isArrangementGroupEntity() && (cocosplanManager.selectedEntities[i] as ArrangementGroup).isUnbreakableGroup()) {
                    merge = false;
                    break;
                }
            }

            if (merge) {
                cocosplanManager.executeCommand(new Commands.MergeGroupCommand(cocosplanManager.selectedEntities as ArrangementGroup[]));
            }
        }
        return null;
    }
    actionUngroup(): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();
        var selection = cocosplanManager.selectedEntities.slice();

        for (var i = 0 ; i < selection.length ; i++) {
            if (selection[i].isArrangementGroupEntity() && !(selection[i] as ArrangementGroup).isUnbreakableGroup()) {
                cocosplanManager.executeCommand(new Commands.DeleteGroupCommand(selection[i] as ArrangementGroup));
            }
            if (selection[i].isGeometryGroupEntity()) {
                cocosplanManager.executeCommand(new Commands.DeleteGeometryGroupCommand(selection[i] as GeometryGroup));
            }
            if (selection[i].isArrangementObjectEntity()) {
                var children = selection[i].getChildren([SceneConstants.EntityType.ArrangementGroup, SceneConstants.EntityType.ArrangementObject], null);
                var childrenToUngroup = [];

                for (var j = 0; j < children.length; j++) {
                    if (!children[j].isGhost()) {
                        childrenToUngroup.push(children[j]);
                    }
                }

                if (childrenToUngroup.length > 0) {
                    cocosplanManager.executeCommand(new Commands.EntitiesLeaveGroupCommand(childrenToUngroup, selection[i]));
                }
            }
        }
        return null;
    }

    actionLeaveGroup(params?: any): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();

        var entity;
        if (params) {
            entity = params.getUserData();
        }
        if (!entity) {
            entity = cocosplanManager.selectedEntities[0];
        }
        if (!entity) {
            return(null);
        }
        if (entity.parent && entity.parent.isArrangementGroupEntity() && entity.parent.isUnbreakableGroup()) {
            return(null);
        }
        if ((cocosplanManager.selectedEntities.length === 1) && (entity.parent.isArrangementGroupEntity()) && (entity.parent.iArrangements.length > 2)) {
            cocosplanManager.executeCommand(new Commands.LeaveGroupCommand(entity));
        }
        else {
            if ((cocosplanManager.selectedEntities.length === 1) && (entity.parent.isArrangementObjectEntity())) {
                cocosplanManager.executeCommand(new Commands.LeaveGroupCommand(entity));
            }
            else {
                if ((entity.parent.isArrangementGroupEntity()) && (entity.parent.iArrangements.length <= 2)) {
                    cocosplanManager.executeCommand(new Commands.DeleteGroupCommand(entity.parent));
                }
            }
        }
        return null;
    }
    actionRemoveCoating(params: any): ActionState | null {
        var cocosplanManager = PlanManager.getInstance();

        var entity = params.getUserData();
        if (!entity) {
            entity = cocosplanManager.selectedEntities[0];
        }
        if (entity.isWallEntity()) {
            //Delete both wall coatings or both floor and ceiling coatings
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.wallDirect, undefined as any));
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.wallUndirect, undefined as any));
        } else if (entity.isRoomEntity()) {
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.floor, undefined as any));
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.ceiling, undefined as any));
        } else if (entity.isStaircaseEntity()) {
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.floor, undefined as any));
        } else if (entity.isTechnicalElementEntity()) {
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.technicalElement, undefined as any));
        } else if (entity.isJoineryEntity()) {
            cocosplanManager.executeCommand(new Commands.ChangeCoatingCommand(entity, null, Coating.HangType.joinery, undefined as any));
        }
        cocosplanManager.updateItemsSelected(null);
        return null;
    }

    plusOrLessClickedHandler(event: Event) {
        this.selectedItem = event.getUserData().obj;

        if (!this.hasBeenEdited) {
            this.startEdit();
        }

        if (event.userData.editedProperty === "floorHeight" && event.userData.obj.entityType === SceneConstants.EntityType.ArrangementObject) {
            event.userData.obj.isAnchorActive = false;
        }

        this.capValue(event.userData.obj, event.getUserData().editedProperty, event.userData.value);
        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE);

        //event.userData.obj[event.userData.editedProperty] = event.userData.obj[event.userData.editedProperty] + event.userData.value;
        eventsManager.instance.dispatch(Events.ENTITY_PARAM_EDITED, {
            id: event.userData.obj.id,
            type: event.userData.obj.entityType,
            entity: event.userData.obj,
            key: event.userData.editedProperty
        });

        this.hasBeenEdited = true;
    }

    actionTextFieldEdit(property: string, value: number, obj: Entity, isLast: boolean) {
        this.selectedItem = obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        if (this.selectedItem != null) {
            // Normal property field of an entity
            if ((this.selectedItem as any)[property] !== undefined) {
                (this.selectedItem as any)[property] = value;
            }
        }
        this.hasBeenEdited = true;
    }

    actionTextFieldEditEnded(datas: any) {
        this.selectedItem = datas.obj;

        if (!this.hasBeenEdited) {
            this.startEdit();
        }

        this.hasBeenEdited = true;

        if (datas.editedProperty === "floorHeight" && datas.obj.entityType === SceneConstants.EntityType.ArrangementObject) {
            datas.obj.isAnchorActive = false;
        }
        // ugly
        if (datas.editedProperty === "_colorId") {
            datas.editedProperty = "colorId";
        }
        // Normal property field of an entity
        if (datas.obj[datas.editedProperty] !== undefined) {
            datas.obj[datas.editedProperty] = datas.value;
        }
        else {
            // Property not found, check if this is a functionality chip and in that case, set the property in data if it exists
            if (datas.obj.isFunctionalityChipEntity() || (this.selectedItem !== null && this.selectedItem.isRoomEntity())) {
                if (datas.obj.getData(datas.editedProperty) !== undefined) {
                    datas.obj.setData(datas.editedProperty, datas.value)
                }
            }
        }
        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE);
        eventsManager.instance.dispatch(Events.ENTITY_PARAM_EDITED, {
            id: datas.obj.id,
            type: datas.obj.entityType,
            entity: datas.obj,
            key: datas.editedProperty
        });
    }

    actionChangeArrangementObjectId(datas: any) {
        this.selectedItem = datas.userData.obj;

        if (!this.hasBeenEdited) {
            this.startEdit();
        }

        this.hasBeenEdited = true;
    }

    actionEditEnded() {
        var cocosplanManager = PlanManager.getInstance();

        if (this.hasBeenEdited) {
            if (this.selectedItem != null && this.selectedItem.temporary) {
                if (this.selectedItem instanceof Sun) {
                    cocosplanManager.executeCommand(new Commands.EditSunCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof RenderCamera) {
                    cocosplanManager.executeCommand(new Commands.EditRenderCameraCommand(this.selectedItem, false));
                }
                else if (this.selectedItem instanceof ArrangementObject || this.selectedItem instanceof ArrangementGroup ||
                            this.selectedItem instanceof GeometryGroup) {
                    // This command does the clone itself, passe the original temporary entity before ending the temporary then call the executeCommand
                    cocosplanManager.executeCommand(new Commands.EditEntityCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof FunctionalityChip) {
                    cocosplanManager.executeCommand(new Commands.EditFunctionalityChipCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof GeometryPrimitive) {
                    cocosplanManager.executeCommand(new Commands.EditGeometryPrimitiveCommand(this.selectedItem));
                }
            }
            this.hasBeenEdited = false;
        }

        if (this.selectedItem !== null) {
            // Mouchard
            if (this.selectedItem.endTemporary) {
                this.selectedItem.endTemporary();
            }
        }
        this.selectedItem = null;
    }

    capValue(obj: Entity, property: string, value: number): number {
        return obj.addToCappedProperty(property, value);
    }

    dispose() {
        this.actionEditEnded();

        eventsManager.instance.removeListener(this.imageListener!);
        eventsManager.instance.removeListener(this.plusListener!);
        eventsManager.instance.removeListener(this.lessListener!);
        eventsManager.instance.removeListener(this.modifyListener!);
        eventsManager.instance.removeListener(this.editedListener!);
        eventsManager.instance.removeListener(this.deleteListener!);
        eventsManager.instance.removeListener(this.entityEdition!);
        eventsManager.instance.removeListener(this.chipFuncEditionListener!);
        eventsManager.instance.removeListener(this.chipFuncAddListener!);
        eventsManager.instance.removeListener(this.chipFuncRemoveListener!);
        eventsManager.instance.removeListener(this.coatingDrag!);
        eventsManager.instance.removeListener(this.ungroupEntityListener!);
        eventsManager.instance.removeListener(this.ungroupEntitiesListener!);
        eventsManager.instance.removeListener(this.groupEntitiesListener!);
        eventsManager.instance.removeListener(this.mergeEntitiesListener!);
        eventsManager.instance.removeListener(this.clearCoatingListener!);
        eventsManager.instance.removeListener(this.sunDragOnListener!);
        eventsManager.instance.removeListener(this.sunDragOffListener!);
        eventsManager.instance.removeListener(this.sliderListener!);
        eventsManager.instance.removeListener(this.joineryComponentDrag!);
        eventsManager.instance.removeListener(this.technicalElementComponentDrag!);
    }

    addRoomFunc(functionality: any, room: Room, edit: boolean) {
        var funcList = room.secondaryFunctionalities;
        for (var i = 0; i < funcList.length; i++) {
            if (funcList[i].functionalityId === functionality.id) {
                this.removeRoomFunc(functionality, room, edit);
                break;
            }
        }
        room.addSecondaryFunctionality(functionality.id, functionality.name, functionality.medias.md, functionality.hover.md, undefined as any);
        eventsManager.instance.dispatch(Events.ROOM_SECONDARY_FUNCTIONALITY_CHANGED, {
            room: room,
            functionality,
            edit: edit
        });
    }

    removeRoomFunc(functionality: FunctionalityChip, room: Room, edit: boolean) {
        var chips = room.functionalityChips;
        var chip = null;
        for (var i = 0; i < chips.length; i++) {
            if (chips[i].functionality === functionality.id) {
                chip = chips[i];
                break;
            }
        }
        if (chip !== null) {
            GameObjectManager.deleteFunctionalityChip(chip);
        }
        room.removeFunctionality(functionality.id);
        eventsManager.instance.dispatch(Events.ROOM_SECONDARY_FUNCTIONALITY_CHANGED, {
            room: room,
            functionality,
            edit: edit
        });
    }

    changeToChipFunctionalityEdition(functionality: FunctionalityChip, room: Room) {
        var chips = room.functionalityChips;
        var chip = null;
        for (var i = 0; i < chips.length; i++) {
            if (chips[i].functionality === functionality.id) {
                chip = chips[i];
            }
        }
        if (chip !== null) {
            //TODO Find a way to remove the call to plan manager ?
            var newState = new MoveFunctionalityChipState(room, chip, PlanManager.getInstance()._uiState.cursorPosition, false);
            eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
        } else {
            eventsManager.instance.dispatch(Events.ADD_ROOM_SECONDARY_FUNCTIONALITY, {
                functionality,
                room: room,
                edit: true
            });
        }
    }

    changeToEntityEdition(entity: Entity) {
        var newState = null;

        if (!(entity instanceof WorkTop)) {
            newState = new AddEntityState(entity, false, true);
        }
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }

    changeToCoatingAdd(entity: Entity, coating: Coating) {
        var newState = new DragCoatingState(entity, coating);
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }

    changeToDragTechnicalElement(entity: Entity, component: Component, unicity: boolean, restreintTypeList: number[]) {
        var newState = new DragComponentState(entity, component, unicity, restreintTypeList);
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }
}
